function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}
export {
  bind as default
};
//# sourceMappingURL=axios3.js.map
